import classNames from 'classnames'
import { format, parseISO } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

import { Loader } from '@UI/Loader'

import { convertDeltaToHtml } from '@/lib/convertDeltaToHtml'
import { useGetNotificationsQuery, useLazyGetNotificationsQuery, useSetReadMutation } from '@store/notifications/notifications.api'
import type { TNotifications } from '@store/notifications/type'

import type { NotificationsProps } from './Notifications.props'

const page_size = 4

export function Notifications({ hasUnread, ...props }: NotificationsProps) {
  const [page, setPage] = useState(1)
  const [extra, setExtra] = useState<TNotifications[]>([])

  const { data, isLoading, isError } = useGetNotificationsQuery({ page_size, page: 1 })
  const [trigger, { isLoading: extraIsLoading }] = useLazyGetNotificationsQuery()
  const [readAll] = useSetReadMutation()

  const { ref } = useInView({
    onChange: (inView) => {
      if (inView) {
        trigger({ page_size, page: page + 1 }).then((res) => {
          setExtra((p) => [...p, ...(res.data?.results || [])])
        })

        setPage((p) => p + 1)
      }
    },
    skip: !data || page === Math.ceil(data.count / page_size),
  })

  useEffect(() => {
    hasUnread && readAll({})
  }, [])

  return (
    <div className={classNames('notifications', props.className)}>
      <div className="notifications__top">
        <button
          className="notifications__close"
          onClick={props.onClose}
          id="notifications-close"
        >
          <svg className="notifications__close-svg">
            <use href="/img/sprite.svg#arrow-right"></use>
          </svg>
        </button>
        <span className="notifications__top-name">Сповіщення</span>
      </div>
      <div className="notifications__inner">
        <div className="notifications__block">
          {/*<div className="notifications__head">Нові сповіщення</div>*/}

          {isLoading && <Loader />}
          {isError && <p className="text-center">Щось пішло не так...</p>}
          {data?.results.length ? (
            <ul className="notifications__list">
              {/*<li className="notifications__item notifications__item--orange">*/}
              {/*  <svg className="notifications__item-icon">*/}
              {/*    <use href="/img/sprite.svg#cours"></use>*/}
              {/*  </svg>*/}
              {/*  <div className="notifications__item-text">*/}
              {/*    <span>ДLorem ipsum dolor sit amet consectetur adipisicing elit. Est iusto nihil dolore non ab minima vero eius suscipit eos laborum.</span>*/}
              {/*  </div>*/}
              {/*  <time className="notifications__item-time">15.04.23 — 10:52</time>*/}
              {/*</li>*/}
              {[...data.results, ...extra].map((v) => (
                <NotificationItem
                  key={v.id}
                  {...v}
                />
              ))}
              {extraIsLoading ? (
                <Loader />
              ) : (
                <li
                  ref={ref}
                  style={{ width: '100%', height: 1 }}
                />
              )}
            </ul>
          ) : (
            <p className="text-center">Список пустий...</p>
          )}
        </div>
        {/*<div className="notifications__block">*/}
        {/*  <div className="notifications__head">Переглянуті сьогодні</div>*/}
        {/*  {!!data?.results.filter((v) => v.is_read).length ? (*/}
        {/*    <ul className="notifications__list">*/}
        {/*<li className="notifications__item notifications__item--read">*/}
        {/*  <svg className="notifications__item-icon">*/}
        {/*    <use href="/img/sprite.svg#cours"></use>*/}
        {/*  </svg>*/}
        {/*  <div className="notifications__item-text">*/}
        {/*    <span>Додано курс «Образотворче мистецтво»</span>*/}
        {/*  </div>*/}
        {/*  <time className="notifications__item-time">15.04.23 — 10:52</time>*/}
        {/*</li>*/}
        {/*{data?.results*/}
        {/*  .filter((v) => v.is_read)*/}
        {/*  .map((v) => (*/}
        {/*    <NotificationItem*/}
        {/*      key={v.id}*/}
        {/*      {...v}*/}
        {/*    />*/}
        {/*  ))}*/}
        {/*</ul>*/}
        {/*) : (*/}
        {/*  <p className="text-center">Список пустий...</p>*/}
        {/*)}*/}
        {/*</div>*/}
      </div>
    </div>
  )
}

function NotificationItem({ ...props }: TNotifications) {
  return (
    <li className={classNames('notifications__item', { 'notifications__item--blue': !props.is_read, 'notifications__item--read': props.is_read })}>
      <svg className="notifications__item-icon">
        <use href="/img/sprite.svg#warn"></use>
      </svg>
      <div className="notifications__item-text">
        <div dangerouslySetInnerHTML={{ __html: convertDeltaToHtml(props.content) }} />
        {/*<div className="notifications__date date date--orange">15.04 9:00</div>*/}
      </div>
      <time className="notifications__item-time">{format(parseISO(props.created_at), 'dd.MM.yyyy - HH:mm')}</time>
    </li>
  )
}
